import { useRef } from "react";

import Paper from "@material-ui/core/Paper";

import useImagePickerStyles from "./image-picker.style";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import { useUploadImage } from "../../../hooks";

export type ImageEntry = {
  id: string;
  url: string;
};

export enum ImagePickerType {
  Simple = 0,
  Label = 1,
}

interface ImagePickerProps {
  defaultValue?: string;
  disabled?: boolean;
  onUploaded: (entry: ImageEntry) => void;
  width?: string | number;
  height?: string | number;
  type?: ImagePickerType;
}

export function ImagePicker(props: ImagePickerProps) {
  const { defaultValue, disabled, onUploaded, width, height, type } = props;
  const isSimpleButton = type === ImagePickerType.Simple ?? false;

  const { computeImageUrl, loading, uploadImage } = useUploadImage(
    function onSuccess(image) {
      if (onUploaded) {
        onUploaded({
          id: image.id,
          url: computeImageUrl(image.id),
        });
      }
    }
  );

  const classes = useImagePickerStyles();
  const uploadImagePickerRef = useRef(null);

  const onImagePickerChange = ({
    target: {
      validity,
      files: [file],
    },
  }: any) => {
    if (validity.valid) {
      uploadImage(file);
    }
  };

  return (
    <>
      <input
        hidden
        required
        disabled={disabled}
        ref={uploadImagePickerRef}
        id="upload-image"
        type="file"
        accept="image/*"
        onChange={onImagePickerChange}
      />
      {!isSimpleButton && (
        <Paper className={classes.root} variant="outlined" square>
          {defaultValue && (
            <img
              width={width ?? "auto"}
              height={height ?? "auto"}
              alt=""
              src={defaultValue}
              style={{ objectFit: "contain" }}
            />
          )}
          <label htmlFor="upload-foreground-picker-image">
            {!disabled && (
              <Button
                disabled={loading}
                onClick={() =>
                  uploadImagePickerRef.current &&
                  (uploadImagePickerRef.current as any).click()
                }
                color="primary"
              >
                <Typography variant="h4" color="primary">
                  Carica immagine
                </Typography>
              </Button>
            )}
          </label>
        </Paper>
      )}
      {isSimpleButton && (
        <Button
          variant="outlined"
          onClick={() =>
            uploadImagePickerRef.current &&
            (uploadImagePickerRef.current as any).click()
          }
        >
          Carica Immagine
        </Button>
      )}
    </>
  );
}
